import { isVue2, isVue3, createApp, h, Vue } from 'vue-demi';

export default {
    mounted: isVue3 ? mounted : undefined,
    bind: isVue2 ? bind : undefined,
};

function mountTooltip(el, binding) {
    let tooltipEl;
    let tooltipVm;

    const showTooltip = () => {
        if (!binding.value) return;

        tooltipEl = document.createElement('div');
        tooltipEl.style.position = 'absolute';
        tooltipEl.style.background = 'rgba(0, 0, 0, 0.85)'; // darker, no white
        tooltipEl.style.color = '#fff';
        tooltipEl.style.padding = '6px 12px';
        tooltipEl.style.borderRadius = '4px';
        tooltipEl.style.pointerEvents = 'none';
        tooltipEl.style.zIndex = '99999'; // very high
        tooltipEl.style.whiteSpace = 'nowrap';
        tooltipEl.style.transition = 'opacity 0.2s, transform 0.2s';
        tooltipEl.style.opacity = '0';
        tooltipEl.style.fontSize = '14px';
        tooltipEl.style.fontWeight = '500';
        tooltipEl.style.lineHeight = '1.3';
        tooltipEl.style.boxShadow = '0 2px 8px rgba(0,0,0,0.3)';
        tooltipEl.style.border = 'none';
        tooltipEl.style.userSelect = 'none';
        tooltipEl.style.transform = 'translateY(-4px)';
        tooltipEl.style.backdropFilter = 'blur(2px)'; // subtle blur effect
        tooltipEl.style.maxWidth = '250px';
        tooltipEl.style.wordBreak = 'break-word';

        document.body.appendChild(tooltipEl);

        // HTML string or Vue component
        if (typeof binding.value === 'string') {
            tooltipEl.innerHTML = binding.value;
        } else if (binding.value.component) {
            if (isVue3) {
                const app = createApp({
                    render: () => h(binding.value.component, binding.value.props || {})
                });
                tooltipVm = app.mount(tooltipEl);
                el._tooltipApp = app;
            } else {
                const ComponentClass = Vue.extend(binding.value.component);
                tooltipVm = new ComponentClass({
                    propsData: binding.value.props || {}
                }).$mount();
                tooltipEl.appendChild(tooltipVm.$el);
                el._tooltipVm = tooltipVm;
            }
        }

        const rect = el.getBoundingClientRect();
        tooltipEl.style.left = rect.left + window.scrollX + rect.width / 2 - tooltipEl.offsetWidth / 2 + 'px';
        tooltipEl.style.top = rect.top + window.scrollY - tooltipEl.offsetHeight - 8 + 'px';
        tooltipEl.style.opacity = '1';

        el._tooltipEl = tooltipEl;
    };

    const hideTooltip = () => {
        if (tooltipEl) {
            tooltipEl.remove();
            tooltipEl = null;
        }
        if (tooltipVm && isVue2) {
            tooltipVm.$destroy();
            el._tooltipVm = null;
        }
        if (el._tooltipApp && isVue3) {
            el._tooltipApp.unmount();
            el._tooltipApp = null;
        }
    };

    el.addEventListener('mouseenter', showTooltip);
    el.addEventListener('mouseleave', hideTooltip);
}

function mounted(el, binding) {
    mountTooltip(el, binding);
}

function bind(el, binding) {
    mountTooltip(el, binding);
}